import { Label, TextStyle } from "@lannister/duplo";

const InvoiceDetails = ({ invoiceId, expirationDate, extraDetails }) => {
    const formatDate = () => {
        const [year, month, day] = expirationDate.split("T")[0].split("-");
        return `${day}-${month}-${year}`;
    }

    const renderDetailRow = (key, value) => (
        <div key={key} style={styles.row}>
            <div style={styles.labelWrapper}>
                <Label labelText={key} textStyle={TextStyle.BaseRegular} wrap={true} />
            </div>
            <div style={styles.valueWrapper}>
                <Label labelText={value} textStyle={TextStyle.BaseRegular} wrap={true} />
            </div>
        </div>
    );

    return (
        <div style={styles.card}>
            <Label labelText="Invoice Details" textStyle={TextStyle.Heading5Semibold} />
            <div style={styles.divider} />
            {invoiceId && renderDetailRow("Invoice ID", `#${invoiceId}`)}

            {renderDetailRow("Expiration Date", formatDate())}

            {extraDetails &&
                Object.entries(extraDetails).map(([key, value]) => renderDetailRow(key, value))}
        </div>
    );
};

const styles = {
    card: {
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        alignSelf: "stretch",
        borderRadius: "16px",
        border: "1px solid #E6E8FA",
        background: "#FFF",
    },
    divider: {
        width: "100%",
        height: "1px",
        backgroundColor: "#E6E8FA",
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        alignSelf: "stretch",
        gap: "12px",
        alignItems: "flex-start",
    },
    labelWrapper: {
        flex: "1",
        textAlign: "left",
    },
    valueWrapper: {
        flex: "1",
        textAlign: "right",
    },
};

export default InvoiceDetails;
